import './App.css';
import Footer from './components/Footer'
import Header from './components/Header'
import Cenario from './components/Cenario'
import { useState } from "react"
import {getNodesId} from './components/Animacao';

function App() {
  const [idCenario, setIdCenario] = useState(2)
  const [start, setStart] = useState(false)
  const [distancesC0, setDistancesC0] = useState([6, 10, 4, 1, 5, 5, 4, 5, 5, 3, 1, 6, 3, 4, 4, 6, 8])
  const [distancesC1, setDistancesC1] = useState([6, 10, 4, 1, 5, 5, 4, 5, 5, 3, 1, 6, 3, 4, 4])
  const [distancesC2, setDistancesC2] = useState([6, 10, 4, 1, 5, 5, 4, 5, 5, 3, 1, 6, 3, 4, 4, 5, 5, 3, 1, 6, 3, 4, 4, 6, 8])
  const [showModal, setShowModal] = useState(true);
  const [algorithm, setAlgorithm] = useState('dijkstra');

  const onMudarDistancias = (idCenario) => {
    clear();
    if(idCenario === 0) {
      setDistancesC0([])
      const dist = []
      for(let i = 0; i < 17; i++) { 
        dist.push(Math.floor(Math.random()*10) + 1)
      }
      setDistancesC0(dist)

    } else if (idCenario === 1) {
      setDistancesC1([])
      const dist = []
      for(let i = 0; i < 15; i++) { //N = num de ligações/corredores no Cenario1
        dist.push(Math.floor(Math.random()*10) + 1)
      }
      setDistancesC1(dist)
    } else if (idCenario === 2) {
      setDistancesC2([])
      const dist = []
      for(let i = 0; i < 25; i++) { 
        dist.push(Math.floor(Math.random()*10) + 1)
      }
      setDistancesC2(dist)
    }
  }

  const mudarCenario = (idCenario) => {
    setStart(false);
    setShowModal(false); 
    let numCenario = Math.floor(Math.random()*3)
    while(numCenario === idCenario) {
      numCenario = Math.floor(Math.random()*3)
    }
    setIdCenario(numCenario)

    // Mostrar Selecionar sala alert
    if(numCenario === 0) {
      document.getElementById('alert1').setAttribute("style", "display:none");
      document.getElementById('alert2').setAttribute("style", "display:none");
      document.getElementById('alert0').setAttribute("style", "display:block");
    } else if(numCenario === 1) {
      document.getElementById('alert0').setAttribute("style", "display:none");
      document.getElementById('alert2').setAttribute("style", "display:none");
      document.getElementById('alert1').setAttribute("style", "display:block");
    } else if(numCenario === 2) {
      document.getElementById('alert0').setAttribute("style", "display:none");
      document.getElementById('alert1').setAttribute("style", "display:none");
      document.getElementById('alert2').setAttribute("style", "display:block");
    }
    document.getElementById('alert-achou-caminho').setAttribute("style", "display:none");
    document.getElementById('alert-buscando-caminho').setAttribute("style", "display:none");
  }

  const onStart = () => {
    if(start === true) clear()
    else {
      document.getElementById('alert-buscando-caminho').setAttribute("style", "display:block");
      setStart(true);
    }
}

  const onMudarAlgoritmo = () => { 
    document.getElementById('myDropdown').classList.toggle("show");

    document.getElementById('dijkstra').onclick = function() {
      clear();
      setAlgorithm('dijkstra');
      document.getElementById('myDropdown').classList.toggle("show");
      document.getElementById('alertAlgorithm').setAttribute("style", "display:block");
    }
    document.getElementById('astar').onclick = function() {
      clear();
      setAlgorithm('astar');
      document.getElementById('myDropdown').classList.toggle("show");
      document.getElementById('alertAlgorithm').setAttribute("style", "display:block");
    }
    document.getElementById('bfs').onclick = function() {
      clear();
      setAlgorithm('bfs');
      document.getElementById('myDropdown').classList.toggle("show");
      document.getElementById('alertAlgorithm').setAttribute("style", "display:block");
    }
    document.getElementById('dfs').onclick = function() {
      clear();
      setAlgorithm('dfs');
      document.getElementById('myDropdown').classList.toggle("show");
      document.getElementById('alertAlgorithm').setAttribute("style", "display:block");
    }
    document.getElementById('bellmanFord').onclick = function() {
      clear();
      setAlgorithm('bellmanFord');
      document.getElementById('myDropdown').classList.toggle("show");
      document.getElementById('alertAlgorithm').setAttribute("style", "display:block");
    }
    document.getElementById('floydWarshall').onclick = function() {
      clear();
      setAlgorithm('floydWarshall');
      document.getElementById('myDropdown').classList.toggle("show");
      document.getElementById('alertAlgorithm').setAttribute("style", "display:block");
    }
}

const clear = () => {
  setStart(false);
  setShowModal(false);  
  document.getElementById('alert-achou-caminho').setAttribute("style", "display:none");
  document.getElementById('alert-buscando-caminho').setAttribute("style", "display:none");
  
  var nodesInShortestPathOrder = getNodesId()
  if(nodesInShortestPathOrder !== undefined && nodesInShortestPathOrder !== null)
    clearNodesConnections(nodesInShortestPathOrder)
}

const clearNodesConnections = (nodesInShortestPathOrder) => {
  let classNameOrig = idCenario === 0 ? 'sala' : idCenario === 1 ? 'sala-cenario1' : 'sala-cenario2'
  let classNameConnectionV = idCenario === 0 ? 'vertical-connection' : idCenario === 1 ? 'vertical-connection-cenario1' : 'vertical-connection-cenario2'
  let classNameConnectionH = idCenario === 0 ? 'horizontal-connection' : idCenario === 1 ? 'horizontal-connection-cenario1' : 'horizontal-connection-cenario2'
  let classNameConnectionD1 = idCenario === 0 ? 'diagonal-connection-one' : idCenario === 1 ? 'diagonal-connection-one-cenario1' : 'diagonal-connection-one-cenario2'
  let classNameConnectionD2 = idCenario === 0 ? 'diagonal-connection-two' : idCenario === 1 ? 'diagonal-connection-two-cenario1' : 'diagonal-connection-two-cenario2'

  for (let i = 0; i < nodesInShortestPathOrder.length; i++) {
    //Limpar salas
    const node = nodesInShortestPathOrder[i];
    document.getElementById(`${node}`).children.item(0).className = classNameOrig;

    //Limpar connections
    if(i !== nodesInShortestPathOrder.length - 1) { 
      let node1 = nodesInShortestPathOrder[i];
      let node2 = nodesInShortestPathOrder[i+1];
      if (node1 > node2) {
        let aux = node1;
        node1 = node2;
        node2 = aux;
      }
      const connectionId = parseInt('1' + node1.toString() + node2.toString(), 10);
      const connectionType = document.getElementById(`${connectionId}`).children.item(0).id;
     if(connectionType === '111') {
        document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionV;
      } else if(connectionType === '222') {
        document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionH;
      } else if(connectionType === '333') {
        document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionD1;
      } else if(connectionType === '444') {
        document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionD2;
      }           
    }
  }
}

  return (
    <div className={idCenario===0 ? "App" : idCenario===1 ? 'App1' : 'App2'}>
      <Header idCenario={idCenario} onStart={() => onStart()} start={start} onMudarCenario={() => mudarCenario(idCenario)} onMudarDistancias={() => onMudarDistancias(idCenario)} onMudarAlgoritmo={() => onMudarAlgoritmo(algorithm)}/>
      <Cenario showModal={showModal} idCenario={idCenario} start={start} distancesC0={distancesC0} distancesC1={distancesC1} distancesC2={distancesC2} algorithm={algorithm}/> 
      <Footer />
    </div>
  );
}

export default App;
